<template>
    <div class="background">
        <div v-if="load_notification" class="checkoutLoader">
            <div class="LoaderPlacement">
                <div class="digi-table-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        <div class="header">
            <div class="d-flex align-items-center">
                <span class="header-company">DigiCollect</span>
                <span class="product" style="text-decoration:none !important;">
                    <span class="product-logo">
                        <i class="logo-help-desk"></i>
                    </span>
                    <span class="product-name hidden-md-down">DigiHelp</span>
                </span>
            </div>
            <div class="d-flex align-items-center">
                <div class="mr-2 text-white box-shadow isp-active" :class="{'digi-red': !isp_stable}">
                    ISP
                </div>
                <div class="dropdown px-sm-0">
                    <div class="pr-0">
                        <el-dropdown class="pl-2" trigger="click">
                            <span class="el-dropdown-link">
                                <div class="d-flex align-items-center">
                                    <div class="avatar-wrapper position-relative" @click="getNotifications">
                                        <div class="text-center text-white notification-count" v-if="note.unread_count > 0">{{note.unread_count | messageCount}}</div>
                                        <img src="https://cdn.digicollect.com/cdn/scmnew/images/images-new-theme/notification.svg" class="w-85 pointer">
                                    </div>
                                </div>
                            </span>
                            <el-dropdown-menu slot="dropdown" class="searchBoxNavbar pt-0 pb-0">
                                <div class="d-flex justify-content-between px-1 py-3 w-325px w-md-375px">
                                    <div class="lh-24px fs-15 ml-2 fw-500">Notifications ({{note.total}})</div>
                                    <!-- <i class="icon icon-close-circle"></i> -->
                                </div>
                                <div v-if="(ajaxcall && note.list.length == 0)" class="d-flex justify-content-center align-items-center notify-loader">
                                    <half-circle-spinner :animation-duration="1000" :size="35" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <div v-else-if="(!ajaxcall && note.list.length == 0)" class="d-flex justify-content-center align-items-center">
                                    <h6>No Notifications Found</h6>
                                </div>
                                <div v-else class="scroller" @scroll="infiniteScroll">
                                    <el-dropdown-item class="search-custom-note my-1 mx-1" :class="note_in.is_read ? 'selected' : ''" v-for="(note_in, index) in note.list" :key="index">
                                        <div class="d-flex justify-content-between align-items-center" style="border-bottom: solid 1px #e4e4e4;" @click="viewNotification(note_in)">
                                            <div>
                                                <div class="fs-14 messageText" :title="note_in.message">{{note_in.message}}</div>
                                                <div class="fs-12">{{note_in.created_datetime}}</div>
                                            </div>
                                            <div>
                                                <div style="height: 40px;width: 40px;border-radius: 100%;" v-if="note_in.profile_pic" class="d-flex">
                                                    <img :src="note_in.profile_pic"  :alt="note_in.message" class="margin-auto-img" width="40">
                                                </div>
                                                <div style="height: 40px;width: 40px;border-radius: 100%;" v-else>
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png" :alt="note_in.message" class="margin-auto-img" width="40">
                                                </div>
                                            </div>
                                        </div>
                                    </el-dropdown-item>
                                </div>
                                <!-- <el-dropdown-item class="px-0">
                                    <div v-if="(ajaxcall && note.list.length > 0)" class="d-flex justify-content-center align-items-center notify-loader position-absolute" style="left: 45%;bottom:50px">
                                        <half-circle-spinner :animation-duration="1000" :size="35" color="#00448b" style="margin: 0 auto;" />
                                    </div>
                                    <div class="d-flex justify-content-center px-3 py-1 w-325px w-md-375px" style="border-top:1px solid #afafaf">
                                        <div class="lh-30px fs-12 fw-600 text-secondary pointer" @click="gotoNotifications">View All Notifications</div>
                                    </div>
                                </el-dropdown-item> -->
                                <el-dropdown-item class="px-0 bg-white">
                                    <div v-if="(ajaxcall && note.list.length > 0)" class="d-flex justify-content-center align-items-center notify-loader position-absolute" style="left: 45%;bottom:50px">
                                        <half-circle-spinner :animation-duration="1000" :size="35" color="#00448b" style="margin: 0 auto;" />
                                    </div>
                                    <div class="d-flex justify-content-between px-3 py-1 w-325px w-md-375px" style="border-top:1px solid #afafaf">
                                        <div class="lh-30px fs-12 fw-600 text-secondary pointer" @click="gotoNotifications">View All Notifications</div>
                                        <div class="lh-30px fs-12 fw-600 pointer text-secondary" v-if="note.list.length" @click="MarkAllAsRead">Mark All Read</div>
                                        <div class="lh-30px fs-12 fw-600 text-grey" v-else>Mark All Read</div>
                                    </div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <el-dropdown trigger="click" placement="bottom">
                    <span class="el-dropdown-link" @click="getProducts">
                        <el-tooltip class="item" effect="dark" content="Products" placement="bottom">
                            <div class="mr-2 pointer row align-items-center justify-content-center no-gutters p-2 text-white box-shadow">
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/products.svg" class="w-85">
                            </div>
                        </el-tooltip>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <div v-if="is_products_list_api_in_progress" class="p-4">
                            <half-circle-spinner :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;" />
                        </div>
                        <div v-else-if="!is_products_list_api_in_progress && productsList.length <= 0" class="text-center fw-600 py-3 px-4">
                            No Products Found
                        </div>
                        <div v-else class="dropdown-apps uk-grid uk-grid-width-medium-1-3 uk-text-center d-flex align-items-center flex-wrap">
                            <a v-for="(product,index) in productsList" :key="index" :href="product.product_name == 'DigiHelp' ? 'javascript:' : product.public_url" :target="product.product_name == 'DigiHelp' ? '' : '_blank'"
                                class="logoblock px-2">
                                <div class="product-placement">
                                    <i v-if="product.product_name == 'Accounting'" class="logo-accounting-bookeeping material-icons md-36 md-color-orange-600"></i>
                                </div>
                                <div>
                                    <i v-if="product.product_name == 'Cloud'" class="logo-cloud material-icons md-36 md-color-orange-600" style="width: 46px;"></i>
                                </div>
                                <div>
                                    <i v-if="product.product_name == 'Chat'" class="logo-chat material-icons md-36 md-color-light-green-600"></i>
                                </div>
                                <div>
                                    <i v-if="product.product_name == 'DigiHRMS'" class="logo-hrms material-icons md-36 md-color-blue-600 pl-2" > </i>
                                </div>
                                <div>
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/admin.png" v-if="product.product_name == 'DigiAdmin'" class="logo-cloud material-icons md-36 md-color-orange-600 ml-2" style="width: 27px; height: 30px;"/>
                                </div>
                                <div>
                                    <i v-if="product.product_name == 'CRM'" class="logo-crm material-icons md-36 md-color-light-green-600"></i>
                                </div>
                                <div>
                                    <i v-if="product.product_name == 'DigiPOS'" class="logo-pos material-icons md-36 md-color-blue-600"></i>
                                </div>
                                <div class="product-placement">
                                    <i v-if="product.product_name == 'SCM'" class="logo-scm material-icons md-36 md-color-blue-600 pl-2"></i>
                                </div>
                                <div class="mr-1 product-placement">
                                    <i v-if="product.product_name == 'Forms'" class="logo-forms material-icons md-36 md-color-cyan-600"></i>
                                </div>
                                <div class="mr-1">
                                    <i v-if="product.product_name == 'DigiHelp'" class="logo-help-desk material-icons md-36 md-color-blue-600"></i>
                                </div>
                                <div class="">
                                    <i v-if="product.product_name == 'DigiExpense'" class="logo-expence-management material-icons md-36 md-color-blue-600" style="font-size: 22px !important;margin-left: -5px !important;"></i>
                                </div>
                                <span v-if="product.product_name.includes('Digi')" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">{{product.product_name}}</span>
                                <span v-else class="uk-text-muted uk-display-block new-blue mt-2 fw-500">{{'Digi'+product.product_name}}</span>
                                <!-- <span v-if="product.product_name == 'Accounting'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiAccounting</span>
                                <span v-if="product.product_name == 'DigiAdmin'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiAdmin</span>
                                <span v-if="product.product_name == 'Chat'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiChat</span>
                                <span v-if="product.product_name == 'DigiHRMS'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500 pl-1">DigiHRMS</span>
                                <span v-if="product.product_name == 'CRM'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiCRM</span>
                                <span v-if="product.product_name == 'DigiPOS'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiPOS</span>
                                <span v-if="product.product_name == 'SCM'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiSCM</span>
                                <span v-if="product.product_name == 'Forms'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiForms</span>
                                <span v-if="product.product_name == 'DigiHelp'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiHelp</span>
                                <span v-if="product.product_name == 'DigiExpense'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500" style="margin-left: 6px !important;">DigiExpense</span> -->
                                <hr>
                            </a>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
                <!-- <div class="dropdown px-sm-0 mr-2">
                    <div class="dropdown-toggle pointer dropdownhideafter row align-items-center no-gutters text-white box-shadow" role="button" id="dropdownShortcutMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <el-tooltip class="item" effect="dark" content="Products" placement="top">
                            <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/products.svg" class="w-85">
                        </el-tooltip>
                    </div>
                    <product-dropdown></product-dropdown>
                </div> -->
                <div class="language-button dropdown timezone-button d-none d-md-block hidden-md-down">
                    <div class="dropdown-toggle row align-items-center justify-content-center no-gutters px-0 px-sm-4 btn btn-icon text-white products-button" role="button" id="dropdownLanguageMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div class="row no-gutters align-items-center justify-content-center font-weight-bold">
                            <span class="text-white" v-if = "guess" >
                                {{timeDefault}}
                            </span>
                            <span class="text-white" v-else-if = "newyork">
                                {{timeNewYork}}
                            </span>
                            <span class="text-white" v-else-if = "london">
                                {{timeLondon}}
                            </span>
                            <span class="text-white" v-else-if = "kolkata">
                                {{timeKolkata}}
                            </span>
                            <span class="text-white" v-else-if = "singapore">
                                {{timeSingapore}} SGT
                            </span>
                            <span class="text-white" v-else-if = "yangon">
                                {{timeYangon}} MMT
                            </span>
                            <span class="text-white" v-else-if = "bangkok">
                                {{timeThailand}} ICT
                            </span>
                        </div>
                    </div>
                    <div class="dropdown-menu dropdown-time timezone" aria-labelledby="dropdownLanguageMenu">
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3" v-on:click = ' guess = false, newyork = true, london=false, kolkata=false, singapore=false, bangkok=false, yangon=false'>{{timeNewYork}}</span>
                            </div>
                        </a>
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3"  v-on:click = ' guess = false, newyork = false, london=true, kolkata=false, singapore=false, bangkok=false, yangon=false'>{{timeLondon}}</span>
                            </div>
                        </a>
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3" v-on:click = ' guess = false, newyork = false, london=false, kolkata=true, singapore=false, bangkok=false, yangon=false'>{{timeKolkata}}</span>
                            </div>
                        </a>
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3" v-on:click = ' guess = false, newyork = false, london=false, kolkata=false, singapore=true, bangkok=false, yangon=false'>{{timeSingapore}} SGT</span>
                            </div>
                        </a>
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3"  v-on:click = ' guess = false, newyork = false, london=false, kolkata=false, singapore=false, bangkok=false, yangon=true'>{{timeYangon}} MMT</span>
                            </div>
                        </a>
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3"  v-on:click = ' guess = false, newyork = false, london=false, kolkata=false, singapore=false, yangon=false, bangkok=true'>{{timeThailand}} ICT</span>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="user-menu-button" >
                    <div class="pl-3 pr-2 position-relative">
                        <span class="pointer" @click="showHideCompSwitchDropdown">
                            <div class="d-flex align-items-center" style="background-color: #fff; height: 35px; border-radius: 5px;">

                                <span class="username ml-3 d-none d-md-block mr-2 text-truncate"
                                    style="font-size: 14px;padding-top:2px;max-width:100px;color: #00448b;"
                                    :title="loggedInUser.full_name">
                                    {{loggedInUser.full_name}}
                                </span>
                                <div class="avatar-wrapper px-1">
                                    <img class="avatar"
                                        :src="loggedInUser.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" />
                                </div>
                                <!-- <i class="icon icon-chevron-down text-white"></i> -->
                            </div>
                        </span>
                        <div v-if="show_hide_comp_switch_dropdown" @click="onBlurHideCompSwitch" class="switch-company-backdrop">

                        </div>
                        <div v-if="show_hide_comp_switch_dropdown" class="admin-width">
                            <div v-if="user_company.organization_name">
                                <div style="text-align: center;" class="my-3">
                                    <span class="fs-12 fw-600"> This account is managed by <span class="text-capitalize">{{user_company.organization_name}}</span></span>
                                </div>
                            </div>
                            <div class="dropdown-width-responsive">
                                <div class="pt-3">
                                    <hr>
                                    <div class="d-flex align-items-center w-100 pt-2 pb-0">
                                        <div class="switch-user-prpfile ml-4">
                                            <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="loggedInUser.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="70" height="70" />
                                            <div class="col-1 hide-on-mob-screen">
                                                <div class="pointer btn-size">
                                                    <button class="btn btn-secondary btn-smm" :disabled="logout_api_inprogress" @click="logout()">
                                                        Logout
                                                    </button>
                                                </div>
                                                <div class="settings-icon pointer setting-align" @click="goToSettings">
                                                    <img width="18" src="https://testcrm.digicollect.com/static/images/images-new-theme/icons/settings-new-right.svg"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-100 pl-2">
                                            <div class="text-secondary fs-14 pl-2 pr-4">
                                                <span class="fw-800 text-capitalize"
                                                    :title="loggedInUser.full_name">{{loggedInUser.full_name}}</span>
                                                <span class="ml-1 text-gray fw-600 text-capitalize" style="color: #3f3f3f;">({{loggedInUser.user_role.replace(/_/g,' ')}})</span>
                                            </div>
                                            <div class="d-flex main-dropdown justify-content-between pointer pl-2 pr-4 background-default">
                                                <div class="mt-0">
                                                    <h1 class="fs-14 text-gray mb-0 text-capitalize">{{user_company.organization_name}}</h1>
                                                    <h1 v-if="user_company.company_name" class="fs-14 text-gray mb-0 text-secondary text-capitalize">{{user_company.company_name || "-"}} <span class="text-secondary" >(Selected)</span></h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="show-on-mob-screen text-right mx-3">
                                    <button class="btn btn-secondary btn-smm" :disabled="logout_api_inprogress" @click="logout()">
                                        Logout
                                    </button>
                                </div>
                                <hr class="mt-2">
                                <div v-if="org_company_list_loading">
                                    <half-circle-spinner :animation-duration="1000" :size="30" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <template v-else>
                                    <div @scroll="scrollGetOrganizationAndComp" v-if="comp_data.length > 0" class="mt-2" :class="{'overflow-height':comp_data.length > 0}">
                                        <div v-for="(comp, comp_index) in comp_data" :key="comp_index">
                                            <!-- <hr class="mt-5"> -->
                                        <template v-if="loggedInUser.user_has == 'organization'">
                                            <div v-if="comp.company_list">
                                                <div class="d-flex align-items-center w-100 py-2">
                                                    <div class="w-100 px-2">
                                                        <div class="d-flex align-items-center main-dropdown subcompany-dropdown justify-content-between pointer pl-2 pr-4" :class="{'green-active-org':comp_index == 0,'br-t-r-5':comp.org_active}" @click="compActive(comp_index)">
                                                            <div class="d-flex align-items-center">
                                                                <avatar
                                                                    class="navbar-avatar navbar-avatar-org-name"
                                                                    :username="comp.organization_name.replace(/ .*/,'')"
                                                                    :src="''"
                                                                    :size="40"
                                                                    :rounded="false"
                                                                    :color="comp_index == 0 ? '#008b29' : '#ffffff'"
                                                                    :background-color="comp_index == 0 ? '#ffffff' : '#707070'">
                                                                </avatar>
                                                                <div class="mt-0 ml-3">
                                                                    <h1 class="fs-14 mb-0 text-capitalize fw-500" :class="{'text-white':comp_index == 0, 'text-gray':comp_index != 0}">{{comp.organization_name}}</h1>
                                                                </div>
                                                            </div>
                                                            <div v-if="comp.company_list.length > 0" class="mob-left-padding-drop">
                                                                <i style="font-size: 25px;" class="icon el-icon-arrow-up fw-700 org-icon-rotate-transition" :class="{'org-icon-rotate-down':!comp.org_active,'text-white':comp_index == 0, 'dc-text-black':comp_index != 0}"></i>
                                                                <!-- <i style="font-size: 25px;" v-else class="icon el-icon-arrow-down fw-700" :class="{'text-white':comp_index == 0, 'dc-text-black':comp_index != 0}"></i> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="comp.org_active" class="px-2">
                                                    <div v-for="(company, company_index) in comp.company_list" :key="company_index" class="d-flex align-items-center w-100 company-list list-dropdown" v-show="!company.selected">
                                                        <div v-if="company.logo">
                                                            <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="company.logo" width="30" height="30" />
                                                        </div>
                                                        <div v-else>
                                                            <avatar
                                                                class="navbar-avatar navbar-avatar-comp-name"
                                                                :username="company.company_name.replace(/ .*/,'')"
                                                                :src="''"
                                                                :size="30"
                                                                :rounded="false"
                                                                :color="company.selected ? '#ffffff' : '#ffffff'"
                                                                :background-color="company.selected ? '#008b29' : '#707070'">
                                                            </avatar>
                                                        </div>
                                                        <div class="w-100 pl-4">
                                                            <div class="d-flex align-items-center justify-content-between">
                                                                <div>
                                                                    <h1 class="fs-14 mb-0 text-capitalize fw-500" :class="{'text-success':company.selected, 'not-selected':!company.selected}">{{company.company_name}}</h1>
                                                                </div>
                                                                <div v-if="!company.selected" :class="{'cursor-not-allowed': !company.can_company_switch}">
                                                                    <h1 class="fs-14 text-secondary mb-0 pointer fw-500" :class="{'pointer-events-none': !company.can_company_switch}" @click="switchNewCompany(company.company_id, company.can_company_switch)">Switch</h1>
                                                                </div>
                                                                <div v-else class="pr-3">
                                                                    <i class="icon icon-check-circle text-success"></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div v-if="comp.company_list">
                                                <div class="d-flex align-items-center w-100 py-2">
                                                    <div class="w-100 px-2">
                                                        <div class="d-flex align-items-center main-dropdown subcompany-dropdown justify-content-between pointer pl-2 pr-4" :class="{'green-active-org':comp_index == 0,'br-t-r-5':comp.org_active}" @click="compActive(comp_index)">
                                                            <div class="d-flex align-items-center">
                                                                <avatar
                                                                    class="navbar-avatar navbar-avatar-org-name"
                                                                    :username="comp.organization_name.replace(/ .*/,'')"
                                                                    :src="''"
                                                                    :size="40"
                                                                    :rounded="false"
                                                                    :color="comp_index == 0 ? '#008b29' : '#ffffff'"
                                                                    :background-color="comp_index == 0 ? '#ffffff' : '#707070'">
                                                                </avatar>
                                                                <div class="mt-0 ml-3">
                                                                    <h1 class="fs-14 mb-0 text-capitalize fw-500" :class="{'text-white':comp_index == 0, 'text-gray':comp_index != 0}">{{comp.organization_name}}</h1>
                                                                </div>
                                                            </div>
                                                            <div v-if="comp.company_list.length > 0" class="mob-left-padding-drop">
                                                                <i style="font-size: 25px;" class="icon el-icon-arrow-up fw-700 org-icon-rotate-transition" :class="{'org-icon-rotate-down':!comp.org_active,'text-white':comp_index == 0, 'dc-text-black':comp_index != 0}"></i>
                                                                <!-- <i style="font-size: 25px;" v-else class="icon el-icon-arrow-down fw-700" :class="{'text-white':comp_index == 0, 'dc-text-black':comp_index != 0}"></i> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="comp.org_active" class="px-2">
                                                    <div v-for="(company, company_index) in comp.company_list" :key="company_index" class="d-flex align-items-center w-100 company-list list-dropdown" v-show="!company.selected">
                                                        <div v-if="company.logo">
                                                            <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="company.logo" width="30" height="30" />
                                                        </div>
                                                        <div v-else>
                                                            <avatar
                                                                class="navbar-avatar navbar-avatar-comp-name"
                                                                :username="company.company_name.replace(/ .*/,'')"
                                                                :src="''"
                                                                :size="30"
                                                                :rounded="false"
                                                                :color="company.selected ? '#ffffff' : '#ffffff'"
                                                                :background-color="company.selected ? '#008b29' : '#707070'">
                                                            </avatar>
                                                        </div>
                                                        <div class="w-100 pl-4">
                                                            <div class="d-flex align-items-center justify-content-between">
                                                                <div>
                                                                    <h1 class="fs-14 mb-0 text-capitalize fw-500" :class="{'text-success':company.selected, 'not-selected':!company.selected}">{{company.company_name}}</h1>
                                                                </div>
                                                                <div v-if="!company.selected" :class="{'cursor-not-allowed': !company.can_company_switch}">
                                                                    <h1 class="fs-14 text-secondary mb-0 pointer fw-500" :class="{'pointer-events-none': !company.can_company_switch}" @click="switchNewCompany(company.company_id, company.can_company_switch)">Switch</h1>
                                                                </div>
                                                                <div v-else class="pr-3">
                                                                    <i class="icon icon-check-circle text-success"></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center w-100 company-list list-dropdown" v-else>
                                                <div v-if="comp.logo">
                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="comp.logo" width="30" height="30" />
                                                </div>
                                                <div v-else>
                                                    <avatar
                                                        class="navbar-avatar navbar-avatar-comp-name"
                                                        :username="comp.company_name.replace(/ .*/,'')"
                                                        :src="''"
                                                        :size="30"
                                                        :rounded="false"
                                                        :color="comp.selected ? '#ffffff' : '#ffffff'"
                                                        :background-color="comp.selected ? '#008b29' : '#707070'">
                                                    </avatar>
                                                </div>
                                                <div class="w-100 pl-4">
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <div>
                                                            <h1 class="fs-14 mb-0 text-capitalize fw-500" :class="{'text-success':comp.selected, 'not-selected':!comp.selected}">{{comp.company_name}}</h1>
                                                        </div>
                                                        <div v-if="!comp.selected" :class="{'cursor-not-allowed': !comp.can_company_switch}">
                                                            <h1 class="fs-14 text-secondary mb-0 pointer fw-500" :class="{'pointer-events-none': !comp.can_company_switch}" @click="switchNewCompany(comp.company_id, comp.can_company_switch)">Switch</h1>
                                                        </div>
                                                        <div v-else class="pr-3">
                                                            <i class="icon icon-check-circle text-success"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="user-menu-button dropdown">
                    <div class="dropdown-toggle row align-items-center no-gutters px-2 px-sm-4 text-white" role="button" :title="loggedInUser.full_name" id="dropdownUserMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div class="avatar-wrapper">
                            <img class="profile-avatar" :src="loggedInUser.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" />
                        </div>
                        <div class="col pointer fs-14 pl-1">
                            <span class="username font-weight-bold mx-2 d-none d-md-block text-white text-truncate" style="max-width:100px;">{{loggedInUser.full_name}}</span>
                            <span class="username mx-2 d-none d-md-block text-white text-truncate max-width" :title="loggedInUser.email">{{loggedInUser.email}}</span>
                        </div>
                    </div>
                    <div class="dropdown-menu logout logoutborder min-wid" @click="logout()" aria-labelledby="dropdownUserMenu">
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <i class="icon-logout"></i>
                                <span class="px-3">Logout</span>
                            </div>
                        </a>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="mt-3 d-flex justify-content-left">
            <menubar></menubar>
        </div>
        <switch-company-success v-if="switch_success" @hideSuccess="hideSuccess" modal_name="switch-success" :company_success_msg="company_success_msg"></switch-company-success>
    </div>
</template>
<script>
import { HalfCircleSpinner } from "epic-spinners";
import { EventBus } from './eventBus/nav-bar-event.js'
import global from "./global.js"
import notification from './mixins/notification';
const Menubar = () => import('./Menubar');
const ProductDropdown = () => import('./ProductDropdown');
const NotificationDropdown = () => import('./Notification/NotificationDropdown')
const SwitchCompanySuccess = () => import('./SwitchCompanySuccess');
import navbarMixin from './mixins/navbarMixin.js';
import moment from 'moment-timezone';
import Axios from 'axios';
import Avatar from 'vue-avatar';
export default {
    mixins: [navbarMixin, notification],
    data() {
        return {
            isp_stable: false,
			productsList: [],
            products: [],
            timeDefault: moment().tz(moment.tz.guess()).format('LTS z'),
            timeNewYork: moment().tz('America/New_York').format('LTS z'),
            timeLondon: moment().tz('Europe/London').format('LTS z'),
            timeKolkata: moment().tz("Asia/Kolkata").format('LTS z'),
            timeSingapore: moment().tz("Asia/Singapore").format('LTS'),
            timeYangon: moment().tz("Asia/Yangon").format('LTS'),
            timeThailand: moment().tz("Asia/Bangkok").format("HH:mm:ss"),
            timedefault: "",
            guess: true,
            newyork: false,
            london: false,
            kolkata: false,
            singapore: false,
            yangon: false,
            bangkok: false,
            comp_data: [],
            skip: 0,
            search_key: '',
            comp_limit: 10,
            given_comp_index: 0,
            new_token: "",
            comp_active: false,
            switch_success: false,
            company_success_msg:'',
            show_hide_comp_switch_dropdown: false,
            user_company: [],
            org_comp_count: 0,
            scroll_flag: false,
            ajaxcall: false,
            note: {
                skip: 0,
                limit: 10,
                search_key: '',
                list: [],
                total: 0,
                count: 0,
                unread_count: 0
            },
            load_notification: false,
            org_company_list_flag: false,
            org_company_list_loading: false,
            is_products_list_api_in_progress: false,
            logout_api_inprogress: false,
        };
    },
    components: {
        Menubar,
        ProductDropdown,
        HalfCircleSpinner,
        NotificationDropdown,
        SwitchCompanySuccess,
        Avatar
    },
    methods: {
        async MarkAllAsRead(){
            this.load_notification = true
            await this.markAllAsReadApi({
                is_read_all:true
            })
            EventBus.$emit('updateMarkAllRead')
            this.getNotifications();
            this.load_notification = false
        },
        gotoNotifications(){
            this.$router.push({name: 'NotificationsPage'})
        },
        viewNotification(note){
            this.$router.push({
                path: '/notifications_page',
                query: {
                    id: note.notification_id,
                    is_read: note.is_read
                }
            })
            this.getNotifications()
        },
        async getNotifications(){
            try {
                this.ajaxcall = true
                let params ={
                    skip: this.note.skip,
                    limit: this.note.limit,
                    search_key:this.note.search_key
                }
                let res = await this.getNotificationList(params)
                this.note.list = res.response.notifications
                this.note.list.forEach((x) => {
                    if(x.hasOwnProperty('created_time')){
                        x.created_to_array = x.created_time.split(',')
                        x['time']= x.created_to_array[1].trim()
                        x['date']= x.created_to_array[0]
                        x['created_datetime'] = moment(new Date(x.date + ' ' + x.time)).format("Do MMM YYYY | h:mm A")
                    }
                })
                this.note.total = res.response.count
                this.note.count = this.note.list.length
                this.note.unread_count = this.note.total - res.response.read_count
                this.ajaxcall = false
            } catch (reason) {
                console.log(reason)
            }
        },
        async infiniteScroll(e) {
            const {
            target
            } = e;
            if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                try {
                    this.ajaxcall = true
                    let params = {
                        skip: this.note.count,
                        limit: this.note.limit,
                        search_key:this.note.search_key,
                    }
                    let response = await this.getNotificationList(params)
                    if (response.response.skip == this.note.count) {
                        let tempFiles = response.response.notifications
                        tempFiles.forEach(el => {
                            this.note.list.push(el)
                        })
                        this.note.list.forEach((x) => {
                            if(x.hasOwnProperty('created_time')){
                                x.created_to_array = x.created_time.split(',')
                                x['time']= x.created_to_array[1].trim()
                                x['date']= x.created_to_array[0]
                                x['created_datetime'] = moment(new Date(x.date + ' ' + x.time)).format("Do MMM YYYY | h:mm A")
                            }
                        })
                        this.note.list = this.note.list.filter((thing, index) => {
                            const payload = JSON.stringify(thing);
                            return index === this.note.list.findIndex(obj => {
                                return JSON.stringify(obj) === payload;
                            });
                        });
                        this.note.count += response.response.notifications.length
                        this.ajaxcall = false
                    }
                } catch (reason) {
                    this.ajaxcall = false
                    console.log(reason)
                }
            }
        },
        showHideCompSwitchDropdown() {
            this.show_hide_comp_switch_dropdown = !this.show_hide_comp_switch_dropdown;
            if(this.org_company_list_flag == false) {
                this.getOrganizationAndComp();
            }
        },
        onBlurHideCompSwitch(e) {
            if (this.$el.contains(e.target)) {
                this.show_hide_comp_switch_dropdown = false
            }
        },
        async getProducts() {
            try {
                this.is_products_list_api_in_progress = true;
                let params = {
                    skip: 0,
                    limit: 10,
                    search_key: ""
                }
                let res = await this.$http.get(global.ADMIN_API + `/products/list?skip=${params.skip}&limit=${params.limit}&search_key=${params.search_key}`);
                if (res.data.status_id == 1) {
                    this.productsList = res.data.response;
                }
                this.is_products_list_api_in_progress = false;
            }
            catch(err) {
                this.is_products_list_api_in_progress = false;
            }
        },
        async logout() {
            this.logout_api_inprogress = true;
            EventBus.$emit('UnSubscribe')
            localStorage.removeItem('StoreFilterData')
            await Axios.get(global.ADMIN_API + '/auth/logout').then((resp)=>{
                if(resp.data.status_id == 1) {
                    this.$cookie.delete("Token");
                    this.$cookie.delete('Token', {
                        domain: 'digicollect.com'
                    });
                    window.location.href = global.HELP_URL;
                }
            }).catch((err)=>{
                this.$cookie.delete("Token");
                this.$cookie.delete('Token', {
                    domain: 'digicollect.com'
                });
                window.location.href = global.HELP_URL;
            })
            setTimeout(() => {
                this.logout_api_inprogress = false;
            }, 5000);
        },
        checkISP(){
            setInterval(() => {
                if(navigator.onLine){
                    this.isp_stable = true
                }
                else{
                    this.isp_stable = false
                }
            }, 1000);
        },
        setCookie(days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = "Token" + "=" + (this.new_token || "") + expires + ";domain=.digicollect.com; path=/";
        },
        hideSuccess() {
            this.switch_success = false;
            this.setCookie(7);
            setTimeout(() => {
                window.location.reload();
            }, 500);
        },
        goToSettings() {
            if(location.origin.startsWith('https://testhelpdesk.digicollect.com') || location.origin.startsWith('http://localhost')){
                window.open('https://testadmin.digicollect.com/','_blank');
            }else if(location.origin.startsWith('https://helpdesk.digicollect.com')){
                window.open('https://admin.digicollect.com/','_blank');
            }
            this.show_hide_comp_switch_dropdown = false
            // this.$router.push('/settings?type=general');
        },

        compActive(index) {
            this.comp_data[index].org_active = !this.comp_data[index].org_active
            this.$forceUpdate();
        },
        async getOrganizationAndComp() {
            try {
                this.org_company_list_loading = true;
                let param = {
                    skip: this.skip,
                    limit: this.comp_limit,
                    search_key: this.search_key,
                    is_company_switcher: true,
                    product: "DigiHelp"
                };
                let response = await this.getHierarchyListView(param);
                if(response.status_id == 1) {
                    this.comp_data = response.response;
                    this.user_company = response.user_company;
                    if(this.loggedInUser.user_has == 'organization') {
                        this.comp_data.forEach((element, index) => {
                            element['org_active'] = false
                            element.company_list.forEach((element1, index1) => {
                                if(element1.selected) {
                                    this.outer_el = index;
                                    this.inner_el = index1;
                                }
                                return;
                            });
                            return;
                        });
                        var element = this.comp_data[this.outer_el];
                        var element1 = element.company_list[this.inner_el];
                        element.company_list.splice(this.inner_el, 1);
                        element.company_list.splice(0, 0, element1);
                        this.comp_data.splice(this.outer_el, 1);
                        this.comp_data.splice(0, 0, element);
                    } else if(this.loggedInUser.user_has == 'company') {
                        this.comp_data.forEach((element, index) => {
                            if(element.selected) {
                                this.outer_el = index;
                            }
                            return;
                        });
                        var element = this.comp_data[this.outer_el];
                        this.comp_data.splice(this.outer_el, 1);
                        this.comp_data.splice(0, 0, element);
                    }
                    this.org_comp_count = response.response.length;
                    this.org_company_list_flag = true;
                    this.org_company_list_loading = false;
                }
            }
            catch(err) {
                // console.log(err);
                this.org_company_list_flag = false;
                this.org_company_list_loading = false;
            }
        },
        async scrollGetOrganizationAndComp(e) {
			if(this.scroll_flag == false) {
                const {target} = e;
                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                    //this code will run when the user scrolls to the bottom of this div so
                    //you could do an api call here to implement lazy loading
                    try {
                        let param = {
                            skip: this.org_comp_count,
                            limit: this.comp_limit,
                            search_key: this.search_key,
                            is_company_switcher: true,
                            product: "DigiHelp"
                        };
                        let response = await this.getHierarchyListView(param);
                        if(response.status_id == 1) {
                            if (response.skip == this.org_comp_count) {
                                let tempFiles = response.response
								this.scroll_flag = response.response.length ? false : true
                                tempFiles.forEach(el => {
                                        this.comp_data.push(el)
                                })
                                if(this.loggedInUser.user_has == 'organization') {
                                    this.comp_data.forEach((element, index) => {
                                        if(element.hasOwnProperty('org_active')) {
                                            if(element.org_active == false) {
                                                element['org_active'] = false
                                            } else {
                                                element['org_active'] = true
                                            }
                                        } else {
                                            element['org_active'] = false
                                        }
                                        element.company_list.forEach((element1, index1) => {
                                            if(element1.selected) {
                                                this.outer_el = index;
                                                this.inner_el = index1;
                                            }
                                            return;
                                        });
                                        return;
                                    });
                                    var element = this.comp_data[this.outer_el];
                                    var element1 = element.company_list[this.inner_el];
                                    element.company_list.splice(this.inner_el, 1);
                                    element.company_list.splice(0, 0, element1);
                                    this.comp_data.splice(this.outer_el, 1);
                                    this.comp_data.splice(0, 0, element);
                                } else if(this.loggedInUser.user_has == 'company') {
                                    this.comp_data.forEach((element, index) => {
                                        if(element.selected) {
                                            this.outer_el = index;
                                        }
                                        return;
                                    });
                                    var element = this.comp_data[this.outer_el];
                                    this.comp_data.splice(this.outer_el, 1);
                                    this.comp_data.splice(0, 0, element);
                                }
                                this.org_comp_count += response.response.length;
                            }
                        }
                    } catch (reason) {

                    }
                }
            }
        },
        async switchNewCompany(comp_id) {
            try {
                let params = {
                    company_id: comp_id
                }
                let response = await this.switchCompany(params);
                if(response.token) {
                    this.new_token = response.token;
                    this.$cookie.delete("Token");
                    this.$cookie.delete('Token', {
                        domain: 'digicollect.com'
                    });
                    this.show_hide_comp_switch_dropdown = false
                    this.switch_success = true;
                    setTimeout(() => {
                        this.$modal.show('switch-success');
                    }, 500);
                }
                this.company_success_msg = response.message
            }
            catch(err) {
                console.log(err);
            }
        }
    },
    computed: {
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        }
    },
    async mounted(){
        this.checkISP()
        // this.getProducts();
        setInterval(() => {
            (this.timeDefault = moment().tz(moment.tz.guess()).format("HH:mm:ss z")),
            (this.timeNewYork = moment().tz("America/New_York").format("HH:mm:ss z")),
            (this.timeLondon = moment().tz("Europe/London").format("HH:mm:ss z")),
            (this.timeKolkata = moment().tz("Asia/Kolkata").format("HH:mm:ss z")),
            (this.timeSingapore = moment().tz("Asia/Singapore").format("HH:mm:ss")),
            (this.timeYangon = moment().tz("Asia/Yangon").format("HH:mm:ss")),
            (this.timeThailand = moment().tz("Asia/Bangkok").format("HH:mm:ss"));
        }, 1000)
        // this.getOrganizationAndComp();
        // this.getNotifications()
        EventBus.$on('updateNotificationRead', () => {
            this.getNotifications()
        })
        EventBus.$on('RecallFBNotification', () => {
            this.getNotifications()
        })
    },
    filters: {
        messageCount: function (value) {
            if (!value) {
                return 0;
            }
            return value > 99 ? '99+' : value;
        }
    },
    destroyed(){
        EventBus.$off('updateNotificationRead')
    }
};
</script>
<style scoped>
.background{
    background-color: #00448b;
    width: 100%;
    padding: 13px 15px 0px 15px;
    user-select: none;
}
.header{
    display: flex;
    color: #fff;
    align-items: center;
    justify-content: space-between;
}
.header-company{
    font-weight: 600;
    font-size: 20px;
    letter-spacing: 0.04em;
}
.product{
    display: flex;
    align-items: center;
    margin: 0 auto;
    justify-content: center;
    position: absolute;
    left: 0;
    right: 0;
}
.product-logo i{
    color: #fff;
    font-weight: bold;
    text-decoration: none;
    font-size: 17px;
    position: relative;
    top: 2px;
}
.product-name{
    margin-left: 10px;
    color: #fff;
    font-weight: bold;
    font-size: 17px;
    text-decoration: none;
}
.searchContent {
    background-color: #4b9be6;
    color: white;
    border-radius: 50%;
    padding-left: 7px !important;
    padding-right: 5px !important;
    padding-top: 5px !important;
    padding-bottom: 5px !important;
}
.searchContentProduct{
    background-color: #0d5be6;
    color: white;
    border-radius: 50%;
    padding-left: 10px !important;
    padding-right: 10px !important;
    padding-top: 5px !important;
    padding-bottom: 5px !important;
}
.searchProductContent {
    height: 23px;
    width: 14px;
}
.dropdown-toggle.text-white::after {
    color: #fff !important;
}
.dropdown-apps {
    width: 220px !important;
    min-height: 100px;
    max-height: 400px;
    /* overflow-y: auto; */
    top: 11px !important;
}
.dropdown-menu {
    -webkit-border-radius: 8px!important;
    border-radius: 8px!important;
    border: 1px solid #cdd2da!important;
    -webkit-box-shadow: 3px 2px 20px rgba(0,0,0,.2)!important;
    box-shadow: 3px 2px 20px rgba(0,0,0,.2)!important;
}
.dropdown-time {
    top: 11px !important;
}
.uk-margin-bottom {
    margin-bottom: 16px !important;
}
.uk-grid:after,
.uk-grid:before {
    content: "";
    display: block;
    overflow: hidden;
}
[class*="uk-grid-width"] > * {
    box-sizing: border-box;
    width: 100%;
}
.uk-grid-width-medium-1-3 > * {
     width: 33.333%;
}
.uk-margin-top {
    margin-top: 15px !important;
}
@media (min-width: 1220px) {
    .uk-grid > * {
        padding-left: 0px;
    }
}
.uk-grid > * {
    -webkit-box-flex: 0;
    flex: none;
    margin: 0;
    width: 100%;
    padding: 5px 10px 7px 17px;
    border-bottom: solid 1px #cce3fc;
    float: left;
    text-align: center;
    text-decoration: none;
    display: flex !important;
    line-height: 22px;
}
.uk-grid > *:hover {
    text-decoration: none;
    background: #cce3fc !important;
}
.uk-grid > *:last-child {
    border-bottom: solid 0px transparent;
}
i.material-icons.md-36 {
    font-size: 22px !important;
    /* vertical-align: -36px; */
    line-height: 36px;
    height: 36px;
    width: 36px;
    padding-bottom: 15px;
    color: #00448b !important;
}
.uk-grid > * > :last-child {
    margin-bottom: 0;
}
.uk-text-muted {
    color: #212121 !important;
}
.uk-display-block {
    display: block !important;
}
.logoblock .uk-display-block {
    margin-top: 8px;
}
.products-button{
    height: 3.1rem !important;
    line-height: 3.1rem !important;
    border-radius: 100px !important;
    border: 1px solid rgb(184, 223, 255) !important;
    padding: 0px 12.3px !important;
    text-transform: capitalize !important;
    width: 120px;
    max-width: 120px;
}
@media only screen and (max-width: 768px) {
    .app-title.menu-btn-hide {
        padding-left: 13px!important;
    }
    .app-title.menu-btn-hide.menu-btn-show-admin {
        padding-left: 15px!important;
    }
}
.dropdownUser.dropdown-menu{
    border-bottom-left-radius: 15px !important;
    border-bottom-right-radius: 15px !important;
}
.logoutUser{
    box-shadow: 0 -3px 4px 0 rgba(0, 0, 0, 0.16);
    background-color: #e5e5e5;
    text-align: center;
    border-bottom-left-radius: 15px !important;
    border-bottom-right-radius: 15px !important;
}
.logoutUser.dropdown-item:hover{
    box-shadow: 0 -3px 4px 0 rgba(0, 0, 0, 0.16) !important;
    background-color: #e5e5e5 !important;
}
div.title.h6 {
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: 0.6px;
    color: #00448b;
}
.border-img {
    width: 202px;
    height: 2px;
    object-fit: contain;
    border-radius: 19px;
    padding-left: 10px;
    margin-bottom: 5px;
}
.headerproducts {
    padding: 5px 10px 0px 10px;
}
.viewtxt {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: 0.5px;
    color: #303031;
    padding-right: 6px;
}
.search-group {
    margin-bottom: 0px;
    padding: 10px 10px;
}
.input-search {
    position: relative;
}
.input-search .input-search-close, .input-search .input-search-icon {
    position: absolute;
    top: 50%;
    z-index: 1;
    width: 2.573rem;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
}
.input-search .input-search-icon {
    left: 0px;
    font-size: 16px;
    color: #00448b;
    text-align: center;
    pointer-events: none;
    width: 16px;
    height: 16px;
    line-height: 16px;
}
.input-search .input-search-icon+.search-control {
    padding-left: 2.4rem;
}
.search-control:focus + .input-search .input-search-icon {
    color: #00448b !important;
}
.search-control {
    height: 2.573rem;
    -webkit-appearance: none;
    border-color: #00448b;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-transition: -webkit-box-shadow .25s linear,border .25s linear,color .25s linear,background-color .25s linear;
    -o-transition: box-shadow .25s linear,border .25s linear,color .25s linear,background-color .25s linear;
    transition: box-shadow .25s linear,border .25s linear,color .25s linear,background-color .25s linear;
    -moz-appearance: none;
}
.search-control {
    display: block;
    width: 100%;
    padding: .429rem 1.072rem;
    font-size: 14px;
    line-height: 1.571429;
    color: #303031;
    background-color: #fff;
    background-image: none;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border-bottom: 1px solid #cdd2da !important;
    border-radius: 0px;
    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    overflow: visible;
    margin: 0;
}
.search-control:focus {
    border-color: #00448b !important;
}
button.input-search-close {
    -webkit-appearance: none;
    padding: 0;
    cursor: pointer;
    background: 0 0;
    border: 0;
}
.input-search-close.icon {
    font-size: 16px;
    line-height: 16px;
}
.input-search .input-search-close {
    right: 8px;
}
.userWidth{
    width: 185px;
    max-width: 185px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.dropdownUser.dropdown-menu{
    min-width: 33rem !important;
    padding: 0rem 0 !important;
    top: 5px !important;
    left: 22px !important;
}
.dropdown-toggle.dropdownhideafter::after {
  content: none !important;
}
.search-magnify{
    font-size: 19px;
    position: relative;
    right: 3px;
    outline: 0;
}
.box-shadow{
    box-shadow: none !important;
}
.margins{
    margin-bottom:10px;
    margin-top:10px !important;
}
.margin-align{
    margin-bottom:10px;
    margin-top:0px !important;
}
.min-wid{
    min-width: 17rem;
}
.profile-width{
    width: 3.5rem !important;
    min-width: 3.5rem !important;
    height: 3.5rem !important;
}
.max-width{
    max-width: 100px;
}
.profile-avatar{
    width: 40px;
    height: 40px;
}
.username{
    letter-spacing: 0.04rem;
}
.isp-active{
    width: 50px;
    border-radius: 7px;
    padding-left: 14px;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-right: 5px;
    font-size: 16px;
    background: #24af82;
    border: solid 1px #cdd2da;
    font-weight: 500;
    cursor: default !important;
}
.cursor-not-allowed{
    cursor: not-allowed;
}
.pointer-events-none {
    pointer-events: none;
    /* cursor: not-allowed !important; */
}
.settings-icon {
    top:58px;
    right:29px;
    padding: 4.1px 4px 4.1px 4.3px;
    border-radius: 2px;
    /* border: solid 0.5px #00448b;
    background-color: #00448b; */
}
.switch-user-prpfile {
    border-radius: 50%;
    border: 2px solid #ecf1f9;
    width: 75px;
    height: 75px;
}
.company-list {
    border: solid 0.2px rgba(128, 132, 149, 0.05);
    background-color: rgba(13, 91, 230, 0.05);
}
.overflow-height {
    /* height: auto; */
    max-height: 335px;
    min-height: auto;
    overflow-y: auto;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
.mob-left-padding-drop {
    padding-left: 20px;
}
@media screen and (min-width: 400px) {
    .dropdown-width-responsive {
        width: 420px;
    }
    .mob-left-padding-drop {
        padding-left: 0px;
    }
}
@media screen and (max-width: 568px) {
    .header-company{
        display: none;
    }
    .product {
        left: 20px;
        right: auto;
    }
}

@media screen and (max-width: 316px) {
    .isp-active {
        display: none;
    }
}
.admin-width{
    width: 450px;
    max-height: 528px;
    border-radius: 10px !important;
    background-color: #f3f6fb !important;
    box-shadow: 0 2px 0px 0 rgb(0 0 0 / 10%);
    position: absolute;
    right: 8px;
    left: auto;
    top: 100%;
    margin-top: 5px;
    z-index: 11;
    color: #000000;
    padding: 10px 0;
}
.dropdown-width-responsive{
    background-color: #fff;
    border-radius: 10px;
    max-height: 472px;
    margin-left: 15px !important;
    margin-right: 15px !important;
    padding-bottom: 10px;
}
.list-dropdown {
  height: 50px;
  padding: 21px 15px 20.9px 13px;
  border-radius: 0px;
  border: solid 0.3px #ebebeb !important;
  background-color: #faf8f8;
  margin-top: -2px;
}
.main-dropdown {
  border-radius: 5px;
  border: solid 1px #ebebeb;
  background-color: #f7f7f7;
  height: 50px;
  margin-bottom: -7px;
  margin-top: 0px;
}
.main-dropdown.br-t-r-5 {
    border-radius: 5px 5px 0px 0px;
}
.main-dropdown.subcompany-dropdown {
    height: 58px;
}
.setting-align{
    width: 28px;
    margin-top: -65px;
    margin-left: 352px;
    cursor: pointer;
}
.btn-size{
    width: 110px;
    padding: 0 10px !important;
    margin-left: 280px !important;
    margin-top: -36px !important;
}
.btn-secondary{
    border-radius: 12px !important;
}
.background-default{
    background-color: #fff;
    border: solid 1px #fff !important;
}
.open-dropdown{
    border-radius: 5px 5px 0 0;
    border: solid 0.3px #ebebeb;
    height: 50px;
    margin-bottom: -7px;
    margin-top: 5px;
    background-color: #fff;
}
.avatar {
    width: 3rem;
    min-width: 3rem;
    height: 3rem;
    line-height: 4rem;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    font-size: 1.7rem;
    font-weight: 500;
    text-align: center;
    color: #FFFFFF;
    background-color: #fff;
}
.green-active-org {
    background-color: #008b29;
}
.navbar-avatar {
    border-radius: 50% !important;
}
.org-icon-rotate-transition {
    font-size: 24px;
    width: 24px;
    height: 24px;
    line-height: 24px;
}
.org-icon-rotate-transition {
    line-height: 20px;
}
.org-icon-rotate-down.org-icon-rotate-transition {
    transition: all 0.3s;
}
.org-icon-rotate-down {
    transform: rotate(180deg);
}
.hide-on-mob-screen {
    display: block
}
.show-on-mob-screen {
    display: none;
}
.switch-company-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    background-color: rgba(0, 0, 0, 0.16);
}
.position-relative {
    position: relative !important;
}
.notification-count{
    background-color: rgb(199, 51, 51);
    width: 23px;
    position: absolute;
    border-radius: 100%;
    left: 8px !important;
    bottom: 22px;
    height: 20px;
    font-size: 11px;
    font-weight: 600;
    line-height: 20px;
}
.w-85{
	width: 85%;
}
.w-md-375px {
    width: 400px !important;
}
.lh-24px{
    line-height: 24px;
}
.search-custom-note.el-dropdown-menu__item{
    line-height: 25px !important;
    padding: 2px 10px !important;
    border-radius: 6px !important;
}
.search-custom-note{
    background: #e1e7ee !important;
    color: #676767 !important;
}
.search-custom-note.selected{
    background-color: #fff !important
}
.search-custom-note:hover{
    /* font-weight: 500 !important; */
    color: #000 !important;
}

.search-custom-note.selected:hover{
    background-color: transparent !important;
    border-radius: 0px !important;
}
.scroller{
    overflow: auto !important;
    max-height:250px;
}
.messageText{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 325px;
}
.text-grey{
    color:#e4e4e4 !important;
}
.navbar-avatar { font-family: 'Poppins', sans-serif !important;}
@media screen and (max-width: 450px) {
    .admin-width {
        position: fixed;
        top: 50px;
        right: 0;
        left: 0;
        width: 100%;
    }
    .hide-on-mob-screen {
        display: none;
    }
    .show-on-mob-screen {
        display: block;
    }
    .admin-width {
        max-height: 580px;
    }
    .dropdown-width-responsive {
        max-height: 530px;
    }
}
</style>